export const APP_NAME = 'ServeSync Tennis'
export const APP_LOGO_SRC = '/logo512.png'
